import axios from "@util/axios";
import projectConfig from "@projectConfig";
import { isMobile } from "../../../util/browserUtils";
import { prepareSqlOptionFields } from "../utils/formUtils";

const { hostCloud } = projectConfig.api;

export const getForm = async (formId, dataId, subForms, messageId, originForms, loadSqls) => {
   const params = {
      formId,
      subForms,
      originForms,
      loadSqls,
   };

   // Temporary fixes for backend
   if (messageId) params.messageId = messageId;
   if (dataId && dataId !== "0") params.dataId = dataId;

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
      },
      data: {
         endpoint: `/forms-v2`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
      },
   }).then((res) => {
      const formData = res?.data?.default?.mainForm?.forms_data;
      if (formData && loadSqls) {
         prepareSqlOptionFields(formData);
      }

      // Repair numeric values
      const allTabs = res.data.default?.mainForm?.forms_data.tab;
      allTabs?.forEach((tab) => {
         const allElements = tab.elements;
         Object.keys(allElements).forEach((key) => {
            const element = allElements[key];
            if (/* element.enum === "int" ||  */ element.enum === "dec") {
               if (element.value !== "" && element.precision && !Number.isNaN(+element.value)) {
                  const numeric = parseFloat(element.value);
                  element.value = numeric.toFixed(element.precision);
               }
            }
            if (element.enum === "int") {
               element.precision = "0";
            }
         });
      });

      if (isMobile() && res.data.default.mainForm.template) {
         let isAnyFieldVisible = false;
         const allElements = res.data.default.mainForm.forms_data.tab[0].elements;
         Object.keys(allElements).forEach((key) => {
            if (allElements[key].hidden !== "1") {
               isAnyFieldVisible = true;
            }
         });
         if (isAnyFieldVisible) {
            res.data.default.mainForm.template = "";
         }
      }

      /* hideTemplate */
      // Don't render Templates + show all fields - for localhost tests
      /* res.data.default.mainForm.template = "";
      Object.keys(res.data.default.mainForm.forms_data.tab[0].elements).forEach((key) => {
         res.data.default.mainForm.forms_data.tab[0].elements[key].hidden = "0";
      }); */
      return res;
   });
};

export const getDependentFormFields = async (
   formId,
   formKey,
   changedData,
   changedFieldTechname,
   mainFormValues,
) => {
   let finalData = {
      ...changedData,
      easyForm: true,
      UIF_ID: formId,
      changedFieldTechname,
      _cascade_update: true,
   };

   if (mainFormValues) {
      finalData = {
         ...mainFormValues,
         ...finalData,
      };
   }
   if (formKey) finalData["_formKey"] = formKey;

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
      },
      data: {
         endpoint: `/forms-v2`,
         httpMethod: "PUT",
         isAuthenticated: true,
         body: JSON.stringify(finalData, (_, v) => v ?? null),
      },
   });
   // Add prepare prepareSqlOptionFields here
};

export const saveFormV2 = async (formId, formKey, fieldsValues, dataId, instanceId, gridData) => {
   const body = {
      ...fieldsValues,
      UIF_ID: formId,
      easyForm: true,
   };
   if (formKey) body["_formKey"] = formKey;
   if (gridData && Object.keys(gridData).length > 0) {
      body.storeItems = JSON.stringify(gridData);
   }

   const params = {
      instanceId,
   };

   // Temporary fix for backend
   if (dataId && dataId !== "0") {
      params.dataId = dataId;
   }
   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
      },
      data: {
         endpoint: "/forms-v2",
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
         parameters: JSON.stringify(params),
      },
   });
};

export const properlyExecuteStep = async (actionId, comment, stepId, selectedRecipient) => {
   const body = {
      actionId,
      comment,
   };

   if (stepId && selectedRecipient) {
      body.stepId = stepId;
      body.recipientId = selectedRecipient;
   }

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/tasks2/method/executeStepAction",
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};

export const getUpdatedGridRows = async (gridFormId, gridResponseData, formKey) => {
   const params = {
      subFormId: gridFormId,
   };
   if (formKey) params["_formKey"] = formKey;

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/forms-v2/method/updateRowLabels",
         httpMethod: "PUT",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
         body: JSON.stringify(gridResponseData),
      },
   }).then((res) => {
      return res;
   });
};

export const uploadFieldFile = async (formData, uploadUrl) => {
   return axios({
      method: "POST",
      url: uploadUrl,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/multipartFile",
      },
      data: formData,
   });
};

export const getSqlFieldValue = async (fieldId, technames, isDefault, formKey) => {
   let bodyParams = {
      fieldId,
      technames,
   };
   if (isDefault) bodyParams.isDefault = true;
   if (formKey) bodyParams["_formKey"] = formKey;

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/forms/method/getFormFieldSqlData",
         httpMethod: "PUT",
         isAuthenticated: true,
         isResourceHungry: true,
         body: JSON.stringify(bodyParams),
      },
   });
};

export const getSqlFieldValues = async (defaultFields, sqlFields, technames, formKey) => {
   let bodyParams = {
      defaultFields,
      fields: sqlFields,
      technames,
   };

   if (formKey) {
      bodyParams["_formKey"] = formKey;
   }

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/forms/method/getAllSqls",
         httpMethod: "PUT",
         isAuthenticated: true,
         isResourceHungry: true,
         body: JSON.stringify(bodyParams),
      },
   });
};

export const getAlert = async (fieldId, technames, formKey) => {
   const body = {
      fieldId,
      technames,
   };
   if (formKey) body["_formKey"] = formKey;

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/forms-v2/method/getAlert",
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};

export const getAlerts = async (fieldIds, technames) => {
   const body = {
      fieldIds,
      technames,
   };

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/forms-v2/method/getAlerts",
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};
